<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">{{ $t('vincular') }} {{ $t('produto') }}</h1>
            </div>
            <div class="header-buttons">
                <vss-select
                    v-if="shouldShowTipoContratoSelect"
                    ref="tipoContratoInput"
                    :mlLabels="translate"
                    title="Copiar seleção de produtos"
                    :height="45"
                    class="is-100"
                    :value="valorSelecionadoTipoContrato"
                    :options="filteredTipoContratoSelect"
                    @search="() => {}"
                    @input="atualizarTipoContrato"
                    label="key"
                    :closeOnSelect="false"
                    :required="false"
                    multiple
                />
                <button class="delete-btn ml-2 mt-3" type="button" @click="$emit('fecharModal', true)">
                    {{ $t('cancelar') }}
                </button>
                <button
                    class="save-btn mt-3"
                    type="button"
                    @click="save"
                    :disabled="produtoSelected.length === 0"
                >
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-campo-busca-usuario" />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="produtoList"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="produtoSelected"
                :custom-is-checked="
                    (selecionados, linha) => selecionados.idproduto === linha.idproduto
                "
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import ProContratoProdutoService from '@/services/promotor/pro_cliente/ProContratoProdutoService.js';

export default {
    props: {
        idcontrato: 0,
        tipo: {
            type: String,
            default: 'R',
        },
    },
    data() {
        return {
            valorSelecionadoTipoContrato: [],
            translate: true,
            service: new ProContratoProdutoService(this.$http, this.$router),
            produtoList: [],
            produtoSelected: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'codigo', width: null, sortable: true },
                { key: 'produto', width: null, sortable: true },
                { key: 'codigobarra', width: null, sortable: true },
            ],
            tipoContratoSelect: [
                {key:'key-ruptura-troca', value:'R'},
                {key:'key-vencimento', value:'V'},
                {key:'key-tomada-de-preco', value:'T'},
            ],
            debouncedOnSearch: null,
            searchQuery: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [8, 16, 32],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
                column: 'nome',
                order: 'asc',
            },
        };
    },
    computed: {
        filteredTipoContratoSelect() {
            return this.tipoContratoSelect.filter(item => item.value !== this.tipo);
        },
        shouldShowTipoContratoSelect() {
            return this.tipoContratoSelect.some(item => item.value === this.tipo);
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        atualizarTipoContrato(valor) {
            this.valorSelecionadoTipoContrato = valor;
        },
        selecionarOndeCopiarListaDeProdutos() {
            if (this.produtoSelected.length > 0) {
                this.$emit('selecionarProdutos', this.produtoSelected);
                this.$emit('fecharModal', true);
            }

        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.service
                .findAllByContratoNaoAssociados(
                    this.pagination.column,
                    this.pagination.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.idcontrato,
                    this.tipo,
                    this.searchQuery
                )
                .then(this.mapItems)
                .then((value) => {
                    this.produtoList = value;
                    this.isEmpty = this.produtoList.length === 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idcontrato: this.idcontrato,
                    tipo: this.tipo,
                    idproduto: m.idproproduto,
                    codigo: m.idproprodutoerp,
                    produto: m.descricao,
                    codigobarra: m.codigobarra,
                };
            });
        },
        sortTable(field, order) {
            this.pagination.column = field;
            this.pagination.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.searchQuery = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.produtoSelected.length > 0) {
                this.isLoading = true;

                // Adiciona o tipo padrão à lista de tipos para salvar, junto com os tipos selecionados
                const tiposParaSalvar = [
                    { key: 'tipo-padrao', value: this.tipo },
                    ...this.valorSelecionadoTipoContrato
                ];

                const promises = tiposParaSalvar.map(tipoSelecionado => {
                    let temp = this.produtoSelected.map((m) => {
                        return {
                            idcontrato: this.idcontrato,
                            tipo: tipoSelecionado.value,
                            idproduto: m.idproduto,
                        };
                    });

                    return this.service.saveByContrato(temp);
                });

                Promise.all(promises)
                    .then(results => {
                        const allSuccessful = results.every(value => value.content !== null);

                        if (allSuccessful) {
                            this.$emit('fecharModal', true);
                        } else {
                            this.$root.showMessage('error', 'msg-erro-ao-adicionar-associacao', true);
                        }
                    })
                    .catch((e) => {
                        this.$root.showMessage('alert', 'msg-erro-ao-adicionar-associacao', true);
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.$root.showMessage('error', 'msg-selecione', true);
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
